import createAxiosInstance from "@/libs/createAxiosInstance";

const API_URL = process.env.REACT_APP_SSO_URL!;
if (!API_URL) {
  throw new Error("REACT_APP_SSO_URL is not defined");
}
export default createAxiosInstance(API_URL);
